@if(careService()) {
  <div class="text-2xl font-bold text-grey-0 mb-2">Boka tid</div>
  <div class="grow text-left flex flex-col justify-center items-start mb-5">
    <div class="text-left">Boka tid hos <a [routerLink]="careProviderUnitUrl()"
                                           class="font-bold text-duck-blue-2">{{ careProviderUnitName() }}</a>
      för {{ careService().name }}.
    </div>
  </div>
  @if(displayBookingBtn()) {
    <div class="flex justify-stretch items-start lg:items-center lg:justify-start gap-2 flex-col lg:flex-row">
      @if(isInternal()) {
        @if(careServicesTimeSlots()) {
          <div class="flex flex-col min-[400px]:justify-stretch min-[400px]:items-start gap-2 w-full min-[400px]:flex-row lg:w-auto lg:justify-start lg:items-center">
            @for(timeslot of careServicesTimeSlots(); let j = $index; track timeslot.label) {
              <app-ui-button
                [class]="'test-timeslot-' + j"
                [eventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN"
                [eventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                [eventLabel]="careService()?.id.toString()"
                [eventParams]="dataLayerParams()"
                [queryParams]="timeslot?.queryParams"
                [routerLink]="timeslot?.routerLink"
                appGtmEvent
                appGtmGa4Event
                class="grow w-full min-[400px]:w-auto lg:grow-0"
                color="green"
                expanded="block"
                rel="nofollow"
                size="md"
                tabindex="null"
              >{{ timeslot?.label }}
              </app-ui-button>
            }
          </div>
        }
          @for(config of careService().bookingConfigurationData; track config.id) {
            <app-booking-btn
              [bookingConfigurationData]="config"
              [caregiverContactInfo]="careProviderContactInfo()"
              [class]="'booking-btn test-booking-btn'"
              [gaEventAction]="
              eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
            "
              [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
              [gaEventLabel]="careService().id.toString()"
              [hasTimeslots]="careServicesTimeSlots()?.length > 0"
              [index]="0"
              [mainCaregiverUnitType]="mainCaregiverUnitType()"
              [pageType]="pageType"
              class="grow lg:grow-0 block w-full lg:w-auto lg:inline-block"
            ></app-booking-btn>
          }
      }
      @else {
        @for(config of careService().bookingConfigurationData; track config.id) {
          <app-booking-btn
            [bookingConfigurationData]="config"
            [caregiverContactInfo]="careProviderContactInfo()"
            [class]="'booking-btn'"
            [gaEventAction]="
            eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
          "
            [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
            [gaEventLabel]="careService().id.toString()"
            [index]="0"
            [mainCaregiverUnitType]="mainCaregiverUnitType()"
            [pageType]="pageType"
            class="grow lg:grow-0 block w-full lg:w-auto lg:inline-block"
          ></app-booking-btn>
        }
      }
    </div>
  }

}

